export default "__VITE_ASSET__lbhBEF8o__"